/** Цвета осей recharts под тему. Подписи осей recharts рисует атрибутом `fill` (по умолчанию `#666`) —
 *  классом `dark` он не переключается, а на тёмном фоне `#666` тусклый. Светлая тема — прежний `#666`,
 *  тёмная — `--muted-foreground` палитры `.dark` (slate-400). Тема — из `useIsDark()`. */
export const AXIS_TICK_FILL = { light: "#666666", dark: "#94a3b8" } as const;

/** Пропсы `tick` осей recharts: `<XAxis tick={axisTick(isDark)} />`. */
export function axisTick(isDark: boolean, fontSize = 10): { fontSize: number; fill: string } {
  return { fontSize, fill: isDark ? AXIS_TICK_FILL.dark : AXIS_TICK_FILL.light };
}
